import {
    ReactElement,
    useContext,
    createContext,
    PropsWithChildren
} from "react";

export type Renderer<T> = (model: T) => ReactElement;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RendererContext = createContext<Renderer<any>>(() => {
    throw new Error("Not implemented yet.");
});

export function useRenderer<T>(): Renderer<T> {
    return useContext(RendererContext);
}

export type RendererProviderProps<T> = {
    readonly renderer: Renderer<T>;
};

// eslint-disable-next-line react/function-component-definition -- Existing pattern
export function RendererProvider<T>({
    renderer,
    children
}: PropsWithChildren<RendererProviderProps<T>>) {
    return (
        <RendererContext.Provider value={renderer}>
            {children}
        </RendererContext.Provider>
    );
}
